const getCurrentEE = (varParams) => {
    if (!varParams || !varParams.get || !varParams.get("me")) {
        return null;
    }

    const me = varParams.get("me");
    if (!me || !me.exhibitionEvent || !me.eeCurrentId) {
        return null;
    }

    const { exhibitionEvent, eeCurrentId } = me;

    return exhibitionEvent.find((ee) => ee.id === eeCurrentId);
};

const damageReportOldOrNew = (varParams) => {
    if (!varParams || !varParams.get) {
        return "new";
    }

    const moment = varParams.get("moment");
    const ee = getCurrentEE(varParams);

    if (!ee || !ee.created_at || !moment || !varParams.get("damageJobExistTill")) {
        return "new";
    }

    return moment(varParams.get("damageJobExistTill")).diff(ee.created_at, "day") > 0 ? "old" : "new";
};


const ExhibitionHelper = {
    current        : getCurrentEE,
    damageOldOrNew : damageReportOldOrNew
};

export default ExhibitionHelper;